export default "__VITE_ASSET__06775d7e__"